<script setup lang="ts">
import { watch } from 'vue'
import { useRoute } from 'vue-router'
import { useSiteStore } from './stores/site'

const route = useRoute()
const site = useSiteStore()
void site.load()

watch(
  [() => site.browserName, () => site.siteIcon, () => route.path, () => route.meta.title],
  () => {
    if (route.path.startsWith('/visual/show')) return
    const page = String(route.meta.title || '').trim()
    const name = site.browserName
    document.title = page && page !== name ? `${page} · ${name}` : name
    const favicon = document.querySelector<HTMLLinkElement>('link[rel~="icon"]')
    if (favicon && site.siteIcon) favicon.href = site.siteIcon
  },
  { immediate: true }
)
</script>

<template>
  <router-view />
</template>
